import * as React from "react";
import { commitMutation, graphql } from "react-relay";

import { environment } from "~/models";
import { Button } from "~/ui";
import { toast } from "~/ui/";
import { Modal } from "~/ui/legacyFellowIndex";

import type { AsanaDisconnectModalMutation as AsanaDisconnectModalMutationType } from "~/__generated__/AsanaDisconnectModalMutation.graphql";

import styles from "./css/AsanaRemoveProjectModal.module.css";

const AsanaDisconnectModalMutation = graphql`
	mutation AsanaDisconnectModalMutation($input: DisconnectAsanaAccountInput!) {
		disconnectAsanaAccount(input: $input) {
			ok
		}
	}
`;

interface Props {
	onClose: (disconnected: boolean) => void;
}

export default function AsanaDisconnectModal({ onClose }: Props): JSX.Element {
	const onDisconnect = React.useCallback(() => {
		commitMutation<AsanaDisconnectModalMutationType>(environment, {
			mutation: AsanaDisconnectModalMutation,
			variables: {
				input: {},
			},
			onCompleted: ({ disconnectAsanaAccount }) => {
				if (disconnectAsanaAccount?.ok) {
					toast.success(`Disconnected Asana`);
				} else {
					toast.error(`Failed to disconnect Asana`);
				}
				onClose(true);
			},
		});
	}, [onClose]);

	const onCancel = React.useCallback(() => onClose(false), [onClose]);

	return (
		<Modal onClose={onCancel}>
			<Modal.Header noBottomBorder onClose={onCancel}>
				<Modal.Title>Are you sure you want to disconnect Asana?</Modal.Title>
			</Modal.Header>
			<Modal.Body textOnly className={styles.body}>
				Disconnecting Asana will prevent any further action items from syncing with Asana.
			</Modal.Body>
			<Modal.Footer>
				<Button size="normal" onClick={onCancel} className={styles.removeProjectButton}>
					Cancel
				</Button>
				<Button size="normal" variant="destructive" onClick={onDisconnect} className={styles.removeProjectButton}>
					Disconnect
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
